export class WebGpuBackend {
    constructor(context) { }
    initialize(logger, onContextLost, onContextRestored, browserInfo, createOptions) {
        return true;
    }
    release() { }
    setBuffers(clientBuffers) { }
    setBuffersFromTypedArrays(clientBuffers) { }
    onBeforeLoad(openOptions) { }
    onLoaded(fileInfo) { }
    onSeekToTimeCompleted() { }
    onRewind() { }
    onClose() { }
    updateClientBuffers(indices, positions, uvs, normals, staticDraw) { }
    updateMeshFromCompressedBuffers(meshState, sourceBuffers, updateClientBuffers, wasSeeking) {
        return false;
    }
    setTexture(image) { }
    copyVideoTexture() { }
    getWatermark(currentVideo) {
        return [null, false];
    }
}
//# sourceMappingURL=WebGpuBackend.js.map